var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 267,
    r: 245,
    fill: "#f24976"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.659 241.656c18.93-18.928 44.096-29.352 70.863-29.352 18.236 0 35.725 4.842 51.009 13.911V53.763H0v316.91c0 5.5 4.5 10 10 10h229.065c-36.451-39.247-35.59-100.831 2.594-139.017z",
    fill: "#eef6ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.68 370.673V53.763H0v316.91c0 5.5 4.5 10 10 10h22.68c-5.5 0-10-4.5-10-10z",
    fill: "#c3ddf4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.815 0H5.716C2.572 0 0 2.572 0 5.716v50.882h363.531V5.716c0-3.144-2.572-5.716-5.716-5.716z",
    fill: "#293d7c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.396 0H5.716C2.572 0 0 2.572 0 5.716v50.882h22.68V5.716C22.68 2.572 25.252 0 28.396 0z",
    fill: "#1a2b63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.259 178.615c0 2.75-2.25 5-5 5H41.816c-2.75 0-5-2.25-5-5V98.696c0-2.75 2.25-5 5-5h111.442c2.75 0 5 2.25 5 5v79.919h.001z",
    fill: "#69cdff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.496 178.615V98.696c0-2.75 2.25-5 5-5h-22.68c-2.75 0-5 2.25-5 5v79.919c0 2.75 2.25 5 5 5h22.68c-2.75 0-5-2.25-5-5z",
    fill: "#52bbef"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.149 281.788H41.816c-2.75 0-5 2.25-5 5v47.809c0 2.75 2.25 5 5 5h174.246c-5.275-18.909-4.916-39.073 1.087-57.809z",
    fill: "#ff9518"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.496 334.597v-47.809c0-2.75 2.25-5 5-5h-22.68c-2.75 0-5 2.25-5 5v47.809c0 2.75 2.25 5 5 5h22.68c-2.75 0-5-2.25-5-5z",
    fill: "#ef8318"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.149 281.788H180.85v57.809h35.212c-5.275-18.909-4.916-39.073 1.087-57.809z",
    fill: "#ffd00d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#91e0e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.754 101.196H198.165a7.5 7.5 0 010-15h122.589c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM320.754 131.169H198.165a7.5 7.5 0 010-15h122.589a7.5 7.5 0 017.5 7.5 7.5 7.5 0 01-7.5 7.5zM320.754 161.142H198.165a7.5 7.5 0 010-15h122.589c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM320.754 191.115H198.165a7.5 7.5 0 010-15h122.589c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM299.459 213.148H36.816c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5H258.39a99.14 99.14 0 0141.069-15zM239.711 243.662H36.816c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h191.188a100.01 100.01 0 0111.707-15z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.895 34.61c-1.979 0-3.91-.8-5.31-2.191a7.58 7.58 0 01-2.19-5.309c0-1.971.8-3.9 2.19-5.3a7.55 7.55 0 015.31-2.2c1.971 0 3.91.799 5.3 2.2 1.4 1.4 2.2 3.33 2.2 5.3 0 1.979-.8 3.91-2.2 5.309a7.557 7.557 0 01-5.3 2.191z",
    fill: "#e26693"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.49 34.61a7.513 7.513 0 01-7.5-7.5c0-1.971.8-3.9 2.199-5.3 1.4-1.4 3.33-2.2 5.301-2.2a7.55 7.55 0 015.31 2.2c1.39 1.4 2.19 3.33 2.19 5.3s-.801 3.91-2.19 5.299a7.55 7.55 0 01-5.31 2.201z",
    fill: "#ffaf10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.095 34.61c-1.98 0-3.91-.8-5.3-2.191a7.55 7.55 0 01-2.2-5.309 7.51 7.51 0 017.5-7.5c1.97 0 3.91.799 5.3 2.2 1.4 1.4 2.2 3.33 2.2 5.3 0 1.979-.8 3.91-2.2 5.309a7.577 7.577 0 01-5.3 2.191z",
    fill: "#37c47a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M409.768 389.207l-20.555 20.556L429.65 450.2a246.586 246.586 0 0020.556-20.556l-40.438-40.437z",
    fill: "#445ea0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M417.928 376.811l-17.035-17.034a99.825 99.825 0 01-17.512 23.601c-7.066 7.066-15.002 12.945-23.566 17.541l17.003 17.002c1.944 1.945 5.126 1.945 7.071 0l34.039-34.039c1.944-1.944 1.944-5.126 0-7.071z",
    fill: "#293d7c"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M388.484 406.254l-14.54-14.54a99.884 99.884 0 01-14.13 9.204l17.003 17.002c1.944 1.945 5.126 1.945 7.071 0l11.667-11.667a5.013 5.013 0 01-7.071.001z",
    fill: "#1a2b63"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M384.796 240.241c39.916 39.916 39.916 104.634-.001 144.551-39.914 39.913-104.631 39.914-144.55-.001-39.916-39.916-39.914-104.634 0-144.549 39.919-39.917 104.636-39.918 144.551-.001z",
    fill: "#445ea0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M363.197 363.191c-27.986 27.987-73.363 27.987-101.352-.002-27.986-27.984-27.987-73.362 0-101.349 27.986-27.986 73.365-27.985 101.351 0 27.988 27.988 27.988 73.364.001 101.351z",
    fill: "#69cdff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M363.197 363.191a72.143 72.143 0 006.943-8.056c-28.055 20.805-67.855 18.494-93.295-6.946-25.438-25.436-27.748-65.237-6.944-93.292a72.261 72.261 0 00-8.056 6.943c-27.987 27.987-27.986 73.364 0 101.349 27.989 27.989 73.366 27.989 101.352.002z",
    fill: "#52bbef"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M357.815 0H115.912v56.598h247.619V5.716c0-3.144-2.572-5.716-5.716-5.716z",
    fill: "#445ea0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#d9eafc"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 324.83,
    cy: 264.53,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.04,
    cy: 277,
    r: 8.5
  }))));
}

export default __webpack_public_path__ + "15d19e5b62265414f9ed721920dd9923.svg";
export { SvgView as ReactComponent };